import { createSlice } from "@reduxjs/toolkit";

import { getPlan, getAddons } from "./actions";
import {
  getCustomerByEmail,
  otpGeneration,
  verifyOtp,
  getPlanDetails
} from "../actions";

const initialState = {
  loadedFirstTime:false,
  addonsObtained:false,
  planObtanied: false,
  planNotFound: false,
  planDetailsObtained: false,
  planDetails: {},
  loading: false,
  redirect: false,
  targetRedirect: "",
  plan: {},
  addons: [],
  modalOn: false,
  modalLogin: false,
  modalStep: 1,

  sendOtp: false,
  email: "",
  customerName: "",
  customerId: "",
  otpKey: "",
  otpCreated: false,
  redirect: false,
  target: "",
  requestOtp: false
};

const planSlice = createSlice({
  name: "plan",
  initialState: initialState,
  reducers: {
    resetPlan: () => initialState,
    openModal: (state) => {
      state.modalOn = true;
      state.modalStep = 1;
    },
    closeModal: (state) => {
      state.modalOn = false;
      state.sendOtp = false;
      state.modalStep = 1;
      state.otpKey = "";
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getPlan.fulfilled, (state, action) => {
      state.loadedFirstTime = state.addonsObtained && state.planDetailsObtained ? true : false;
      state.planObtanied = action.payload.success ? true : false;
      state.planNotFound = action.payload.success ? false : true;
      state.plan = action.payload.success ? action.payload.data : {};
      state.loading = false;
    });
    builder.addCase(getPlan.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPlan.rejected, (state) => {
      state.planObtanied = false;
      state.loading = false;
      state.plan = {};
    });

    builder.addCase(getAddons.fulfilled, (state, action) => {
      state.loadedFirstTime = state.planObtanied && state.planDetailsObtained? true : false;
      state.addonsObtained = true;
      state.addons = action.payload.success ? action.payload.data : [];
      state.loading = false;
    });
    builder.addCase(getAddons.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAddons.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getCustomerByEmail.fulfilled, (state, action) => {
      state.email = action.payload.success? action.payload.data.email : "";
      state.customerName = action.payload.success? action.payload.data.firstName : "";
      state.customerId = action.payload.success && action.payload.data.customerId ? action.payload.data.customerId : "";
      state.redirect = action.payload.success? false : true;
      state.target = action.payload.success? "" : "/signUp";
      state.sendOtp = action.payload.success? true : false
      state.modalStep = action.payload.success? 1 : 2;
    });
    builder.addCase(getCustomerByEmail.pending, (state) => {
      state.modalLogin = true;
    });
    builder.addCase(getCustomerByEmail.rejected, (state) => {
      state.modalLogin = false;
    });

    builder.addCase(otpGeneration.fulfilled,(state, action) => {
      state.modalLogin = false;
      state.otpKey = action.payload.data.key;
      state.modalStep = 2;
      state.requestOtp = false;
    })
    builder.addCase(otpGeneration.pending, (state) => {
      state.otpCreated = true;
      state.requestOtp = true;
    })
    builder.addCase(otpGeneration.rejected, (state) => {
      state.modalLogin = false;
    })

    builder.addCase(verifyOtp.fulfilled ,(state, action)=>{
      state.modalLogin = false;
      state.redirect = action.payload.success? true : false;
      state.target = action.payload.success? "/payment":"";
    })
    builder.addCase(verifyOtp.pending, (state) => {
      state.modalLogin = true;
    })
    builder.addCase(verifyOtp.rejected, (state) => {
      state.modalLogin = false;
    })

    builder.addCase(getPlanDetails.fulfilled, (state, action) => {
      state.planDetailsObtained = true;
      state.planDetails = action.payload && action.payload.data && action.payload.data.metadata ? action.payload.data.metadata : {allFeatures: [], basicFeatures : []};
      state.loadedFirstTime = state.planObtanied && state.addonsObtained? true : false;
    })
    builder.addCase(getPlanDetails.pending, (state, action) => {})
    builder.addCase(getPlanDetails.rejected, (state, action) => {})
  }
});

export const { openModal, closeModal, resetPlan } = planSlice.actions;
export default planSlice.reducer;